import { Chip, Divider, Grid, IconButton, Link, MenuItem, Paper, Popover, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, Typography, } from "@mui/material";
import * as React from "react";
import "../../../scss/main.scss";
import BackDropComponent from "@/components/BackDrop";
import { getCarrierIcon, getNewDateString } from "@/utils/Common";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { useDispatch } from "react-redux";
import AttachedImagesComponent from "./AttachedImages";
const getStatusLabel = (status) => {
    switch (status) {
        case "accepted_by_seller":
            return "Accepted by seller";
        case "auto_accepted_by_seller":
            return "Auto accepted by seller";
        case "accepted_by_carrier":
            return "Accepted by carrier";
        case "rejected_by_carrier":
            return "Rejected by carrier";
        case "auto_rejected_by_carrier":
            return "Auto rejected by carrier";
        default:
            return "Pending";
    }
};
const getStatusColor = (status) => {
    switch (status) {
        case "accepted_by_seller":
            return "#1976D2";
        case "auto_accepted_by_seller":
            return "#1976D2";
        case "accepted_by_carrier":
            return "#2B873D";
        case "rejected_by_carrier":
            return "#F1583E";
        case "auto_rejected_by_carrier":
            return "#F1583E";
        default:
            return "#BB8734";
    }
};
const getBackgroundColor = (status) => {
    switch (status) {
        case "accepted_by_seller":
            return "#E3F2FD";
        case "auto_accepted_by_seller":
            return "#E3F2FD";
        case "accepted_by_carrier":
            return "#EDFBF1";
        case "rejected_by_carrier":
            return "#FBEAE7";
        case "auto_rejected_by_carrier":
            return "#FBEAE7";
        default:
            return "#BB8734";
    }
};
const headCells = [
    {
        id: "created_on",
        disablePadding: true,
        label: "Created on",
    },
    {
        id: "disputed_closed_on",
        disablePadding: true,
        label: "Disputed closed on",
    },
    {
        id: "order_number",
        disablePadding: true,
        label: "Order number",
    },
    {
        id: "product_details",
        disablePadding: true,
        label: "Product details",
    },
    {
        id: "carrier_details",
        disablePadding: true,
        label: "Carrier details",
    },
    {
        id: "manifested_weight",
        disablePadding: true,
        label: "Manifested weight",
    },
    {
        id: "charged_weight",
        disablePadding: true,
        label: "Charged weight",
    },
    {
        id: "excess_weight",
        disablePadding: true,
        label: "Excess weight & Charges",
    },
    {
        id: "attached_images",
        disablePadding: true,
        label: "Attached images",
    },
    {
        id: "status",
        disablePadding: true,
        label: "Status",
    },
];
function EnhancedTableHead(props) {
    const { rowCount } = props;
    return (React.createElement(TableHead, { sx: { p: 2 }, style: { background: "#FAFBFC" } },
        React.createElement(TableRow, null, headCells.map((headCell) => {
            return (React.createElement(TableCell, { key: headCell.id, align: "left", className: "orderTable_heading_font", padding: "normal", sx: headCell.id === "attached_images"
                    ? {
                        width: "60px",
                        minWidth: "60px",
                        maxWidth: "60px",
                        padding: "4px 8px",
                    }
                    : {} }, headCell.label));
        }))));
}
const ClosedDisputesComponent = ({ selectedCarriersP, setSelectedCarriersP, selectedServicesP, setSelectedServicesP, orderNumbersStrP, setOrderNumbersStrP, AWBstrP, setAWBstrP, handleFilterOpen, handleFilterClose, fetchWeightDiscrepancyData, rowsPerPage, setRowsPerPage, weightDiscrepancy, setWeightDiscrepancy, totalCount, setTotalCount, tabStatus, isFilterApplied, setIsFilterApplied, filterOptions, setFilterOptions, }) => {
    const [discrepancies, setDiscrepancies] = React.useState([]);
    const [isDetailsSliderOpen, setIsDetailsSliderOpen] = React.useState(false);
    const [rowData, setRowData] = React.useState();
    const [anchorElUser, setAnchorElUser] = React.useState(null);
    const [selectedRowData, setSelectedRowData] = React.useState();
    const [isFilterDrawerOpen, setIsFilterDrawerOpen] = React.useState(false);
    const [copyAnchorEl, setCopyAnchorEl] = React.useState(null);
    const dispatch = useDispatch();
    const openCopyPopover = Boolean(copyAnchorEl);
    const copyPopoverId = openCopyPopover ? "simple-popover" : undefined;
    const [orderId, setOrderId] = React.useState("");
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [isOrderIdCopied, setIsOrderIdCopied] = React.useState(false);
    const handleClickOrderId = (event, row) => {
        setCopyAnchorEl(event.currentTarget);
        setOrderId(row === null || row === void 0 ? void 0 : row.orderId);
    };
    const handleCopyAWB = (trackingId) => {
        navigator.clipboard.writeText(trackingId);
    };
    const handleCopyClose = () => {
        setCopyAnchorEl(null);
        setIsOrderIdCopied(false);
    };
    const handleCopyOrderId = (orderId) => {
        setIsOrderIdCopied(true);
        navigator.clipboard.writeText(orderId);
    };
    const [isBackOpenOpen, setIsBackOpenOpen] = React.useState(false);
    const [page, setPage] = React.useState(0);
    const open = Boolean(anchorEl);
    const id = open ? "simple-popover" : undefined;
    const handleOpenUserMenu = (event) => {
        setAnchorElUser(event.currentTarget);
    };
    const handleCloseUserMenu = () => {
        setAnchorElUser(null);
    };
    const handleDetailsSlider = (row) => {
        setIsDetailsSliderOpen(true);
        setRowData(row);
    };
    React.useEffect(() => {
        if ((AWBstrP || selectedCarriersP || selectedServicesP || orderNumbersStrP || filterOptions) && page === 0) {
            setDiscrepancies([...weightDiscrepancy]);
        }
        else {
            setDiscrepancies((prevShipments) => {
                const combined = [...prevShipments, ...weightDiscrepancy];
                return Array.from(new Set(combined.map((shipment) => shipment.orderId))).map((id) => combined.find((shipment) => shipment.orderId === id));
            });
        }
    }, [weightDiscrepancy]);
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
        if (discrepancies.length / rowsPerPage <= newPage) {
            fetchWeightDiscrepancyData(rowsPerPage, newPage);
        }
    };
    const handleChangeRowsPerPage = (event) => {
        const newRowsPerPage = parseInt(event.target.value, 10);
        setRowsPerPage(newRowsPerPage);
        setPage(0);
        fetchWeightDiscrepancyData(newRowsPerPage, 0);
    };
    const handleDisputeDiscrepancy = (selectedRowData) => {
        if (selectedRowData) {
            setSelectedRowData(selectedRowData);
            setIsDetailsSliderOpen(true);
        }
    };
    const handleClosePopOver = () => {
        setAnchorEl(null);
    };
    function handleRejectDispute(row) {
        throw new Error("Function not implemented.");
    }
    function handleAcceptDispute(row) {
        throw new Error("Function not implemented.");
    }
    const visibleRows = React.useMemo(() => {
        return discrepancies.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
    }, [discrepancies, page, rowsPerPage]);
    return (React.createElement(Grid, { container: true, direction: "row", className: "m_background_color" },
        React.createElement(BackDropComponent, { open: isBackOpenOpen }),
        React.createElement(Grid, { className: "order_table_border", sx: { width: "100%", padding: 0, margin: 0 } },
            React.createElement(Paper, { sx: { width: "100%" } },
                React.createElement(TableContainer, null,
                    React.createElement(Table, { sx: { minWidth: 750, width: "100%" }, className: "or_table", "aria-labelledby": "tableTitle", size: "medium" },
                        React.createElement(EnhancedTableHead, { rowCount: weightDiscrepancy === null || weightDiscrepancy === void 0 ? void 0 : weightDiscrepancy.length }),
                        React.createElement(TableBody, { sx: { p: 2 } }, visibleRows &&
                            visibleRows.map((row, index) => {
                                var _a;
                                const labelId = `enhanced-table-checkbox-${index}`;
                                return (React.createElement(TableRow, { hover: true, role: "checkbox", tabIndex: -1, key: row.orderId, sx: { cursor: "pointer" } },
                                    React.createElement(TableCell, { className: "orderTable_font", align: "left" },
                                        React.createElement(Grid, { container: true, direction: "row", alignItems: "center", wrap: "nowrap", gap: 0.5 },
                                            React.createElement(Typography, { sx: {
                                                    fontFamily: "Poppins",
                                                    color: "#121114",
                                                    fontSize: "12px",
                                                    fontWeight: 500,
                                                    whiteSpace: "nowrap",
                                                } }, row.createdAt ? (React.createElement(React.Fragment, null,
                                                React.createElement("div", null, getNewDateString(+row.createdAt).date),
                                                React.createElement("div", { style: { color: "#5F5A6B", fontWeight: 400 } }, getNewDateString(+row.createdAt).time))) : ("-")))),
                                    React.createElement(TableCell, { className: "orderTable_font", align: "left" },
                                        React.createElement(Typography, { sx: { fontFamily: "Poppins", color: "#121114", fontSize: "12px", fontWeight: 500 }, component: "div" }, row.disputeClosedAt && row.createdAt ? (React.createElement(React.Fragment, null,
                                            Math.floor((+row.disputeClosedAt - +row.createdAt) / (1000 * 60 * 60 * 24)),
                                            " days")) : ("-"))),
                                    React.createElement(TableCell, { className: "orderTable_font", align: "left" },
                                        React.createElement(Typography, { sx: { fontFamily: "Poppins", color: "#121114", fontSize: "12px", fontWeight: 500 }, component: "div" }, row === null || row === void 0 ? void 0 : row.orderNumber),
                                        React.createElement(Typography, { className: "orderTable_font", variant: "subtitle2", component: "div" },
                                            React.createElement(Link, { variant: "body2", onClick: (e) => handleClickOrderId(e, row), sx: {
                                                    cursor: "pointer",
                                                    color: "#0C77FF",
                                                    textDecoration: "none",
                                                    fontFamily: "Poppins",
                                                    fontSize: "12px",
                                                    fontWeight: 500,
                                                } }, row === null || row === void 0 ? void 0 :
                                                row.orderId.slice(0, 10),
                                                "..."))),
                                    React.createElement(TableCell, { align: "left" }, (_a = row.productDetails) === null || _a === void 0 ? void 0 : _a.map((product, index) => {
                                        var _a, _b;
                                        return (React.createElement("div", { key: index },
                                            React.createElement(Typography, { variant: "body2", component: "div", sx: {
                                                    textAlign: "left",
                                                    fontFamily: "Poppins",
                                                    fontSize: "11px",
                                                    color: "#5F5A6B",
                                                    fontWeight: 400,
                                                } }, ((_a = product.productName) === null || _a === void 0 ? void 0 : _a.length) > 30
                                                ? `${product.productName.slice(0, 30)}...`
                                                : product.productName),
                                            React.createElement(Typography, { variant: "body2", component: "div", sx: {
                                                    textAlign: "left",
                                                    fontFamily: "Poppins",
                                                    fontSize: "11px",
                                                    color: "#5F5A6B",
                                                    fontWeight: 400,
                                                } },
                                                "SKU: ",
                                                ((_b = product.sku) === null || _b === void 0 ? void 0 : _b.length) > 20 ? `${product.sku.slice(0, 20)}...` : product.sku),
                                            React.createElement(Typography, { variant: "body2", component: "div", sx: {
                                                    textAlign: "left",
                                                    fontFamily: "Poppins",
                                                    fontSize: "11px",
                                                    color: "#5F5A6B",
                                                    fontWeight: 400,
                                                } },
                                                "Qty: ",
                                                product.quantity),
                                            index < (row === null || row === void 0 ? void 0 : row.productDetails.length) - 1 && React.createElement(Divider, { sx: { my: 1 } }),
                                            " "));
                                    })),
                                    React.createElement(TableCell, { align: "left", className: "orderTable_font" },
                                        React.createElement(Grid, { container: true, item: true, direction: "row", justifyContent: "center", alignItems: "flex-start", gap: 1 },
                                            React.createElement(Grid, { item: true, xs: 2 },
                                                React.createElement("img", { className: "m_image_icons", src: getCarrierIcon(`${row === null || row === void 0 ? void 0 : row.carrier}`), alt: "icon", style: { width: "18px", height: "18px", borderRadius: "10px" } })),
                                            React.createElement(Grid, { item: true, xs: 9 },
                                                React.createElement(Typography, { sx: {
                                                        fontFamily: "Poppins",
                                                        color: "#121114",
                                                        fontSize: "12px",
                                                        fontWeight: 500,
                                                    } }, row === null || row === void 0 ? void 0 : row.carrier),
                                                React.createElement(Typography, { sx: {
                                                        fontFamily: "Poppins",
                                                        color: "#5F5A6B",
                                                        fontSize: "11px",
                                                        fontWeight: 400,
                                                    } }, row.service),
                                                React.createElement(Grid, { container: true, direction: "row", alignItems: "center", wrap: "nowrap", gap: 0.5 },
                                                    React.createElement(Typography, { sx: {
                                                            fontFamily: "Poppins",
                                                            color: "#5F5A6B",
                                                            fontSize: "11px",
                                                            fontWeight: 500,
                                                            whiteSpace: "nowrap", // prevents text wrapping
                                                        } },
                                                        "AWB# ",
                                                        row.trackingNumber),
                                                    React.createElement("img", { className: "m_image_icons", src: require("../../../assets/Onboarding/CopyIcon.svg").default, alt: "icon", style: { width: "15px", height: "15px", cursor: "pointer" }, onClick: () => handleCopyAWB(row.trackingNumber) }))))),
                                    React.createElement(TableCell, { align: "left" },
                                        React.createElement(Typography, { variant: "subtitle2", component: "div", className: "orderTable_font", sx: {
                                                textAlign: "left",
                                                fontFamily: "Poppins",
                                                fontSize: "12px",
                                                color: "#121114",
                                                fontWeight: 500,
                                            } }, row === null || row === void 0 ? void 0 :
                                            row.manifestedDeadWeight,
                                            " kg"),
                                        React.createElement(Typography, { variant: "body2", component: "div", sx: {
                                                textAlign: "left",
                                                fontFamily: "Poppins",
                                                fontSize: "10px",
                                                color: "#5F5A6B",
                                                fontWeight: 400,
                                            } },
                                            "Dead Weight: ", row === null || row === void 0 ? void 0 :
                                            row.manifestedDeadWeight,
                                            " kg"),
                                        React.createElement(Typography, { variant: "body2", component: "div", sx: {
                                                textAlign: "left",
                                                fontFamily: "Poppins",
                                                fontSize: "10px",
                                                color: "#5F5A6B",
                                                fontWeight: 400,
                                            } }, "Volumatric Weight"),
                                        React.createElement(Typography, { variant: "body2", component: "div", sx: {
                                                textAlign: "left",
                                                fontFamily: "Poppins",
                                                fontSize: "10px",
                                                color: "#5F5A6B",
                                                fontWeight: 400,
                                            } },
                                            row.volumetricWeight,
                                            "kg (",
                                            row.manifestedLength,
                                            "*",
                                            row.manifestedWidth,
                                            "*",
                                            row.manifestedHeight,
                                            " cm)")),
                                    React.createElement(TableCell, { align: "left", className: "orderTable_font" },
                                        React.createElement(Typography, { variant: "subtitle2", component: "div", className: "orderTable_font", sx: {
                                                textAlign: "left",
                                                fontFamily: "Poppins",
                                                fontSize: "12px",
                                                color: "#121114",
                                                fontWeight: 500,
                                            } }, row === null || row === void 0 ? void 0 :
                                            row.carrierAppliedWeightKg,
                                            " kg"),
                                        React.createElement(Typography, { variant: "body2", component: "div", sx: {
                                                textAlign: "left",
                                                fontFamily: "Poppins",
                                                fontSize: "10px",
                                                color: "#5F5A6B",
                                                fontWeight: 400,
                                            } },
                                            "Charged weight: ",
                                            row.volumetricWeight,
                                            " kg")),
                                    React.createElement(TableCell, { align: "left", className: "orderTable_font" },
                                        React.createElement(Typography, { className: "orderTable_font", variant: "subtitle2", component: "span", sx: { ml: 1 } },
                                            React.createElement(Typography, { variant: "subtitle2", component: "div", className: "orderTable_font", sx: {
                                                    textAlign: "left",
                                                    fontFamily: "Poppins",
                                                    fontSize: "12px",
                                                    color: "#121114",
                                                    fontWeight: 500,
                                                } }, "Excess Weight:"),
                                            React.createElement(Typography, { variant: "body2", component: "div", sx: {
                                                    textAlign: "left",
                                                    fontFamily: "Poppins",
                                                    fontSize: "10px",
                                                    color: "#5F5A6B",
                                                    fontWeight: 400,
                                                } }, row === null || row === void 0 ? void 0 :
                                                row.weightDiscrepancyKg,
                                                " kg"),
                                            React.createElement(Typography, { variant: "subtitle2", component: "div", className: "orderTable_font", sx: {
                                                    textAlign: "left",
                                                    fontFamily: "Poppins",
                                                    fontSize: "12px",
                                                    color: "#121114",
                                                    fontWeight: 500,
                                                } }, "Excess Charges:"),
                                            React.createElement(Typography, { variant: "body2", component: "div", sx: {
                                                    textAlign: "left",
                                                    fontFamily: "Poppins",
                                                    fontSize: "10px",
                                                    color: "#5F5A6B",
                                                    fontWeight: 400,
                                                } },
                                                row.weightDiscrepancyCharges,
                                                " INR"))),
                                    React.createElement(TableCell, { align: "left", className: "orderTable_font", sx: {
                                            width: "60px",
                                            minWidth: "60px",
                                            maxWidth: "60px",
                                            padding: "4px 8px",
                                        } },
                                        React.createElement(Typography, { className: "orderTable_font", variant: "subtitle2", component: "span", sx: { ml: 1, cursor: "pointer" }, onClick: () => handleDisputeDiscrepancy(row) },
                                            React.createElement("img", { src: require(`../../../assets/Onboarding/IconText.svg`).default }))),
                                    React.createElement(TableCell, { align: "left", className: "orderTable_font" },
                                        React.createElement(Typography, { className: "orderTable_font", variant: "subtitle2", component: "span", sx: { ml: 1 } },
                                            React.createElement(Chip, { label: getStatusLabel(row === null || row === void 0 ? void 0 : row.processingStatus), variant: "outlined", size: "small", className: "tr_chip m_font_size_12", style: {
                                                    color: getStatusColor(row === null || row === void 0 ? void 0 : row.processingStatus),
                                                    backgroundColor: getBackgroundColor(row === null || row === void 0 ? void 0 : row.processingStatus),
                                                    border: "none",
                                                } })))));
                            })))),
                React.createElement(TablePagination, { rowsPerPageOptions: [5, 10, 25], component: "div", count: totalCount, rowsPerPage: rowsPerPage, page: page, onPageChange: handleChangePage, onRowsPerPageChange: handleChangeRowsPerPage }),
                "\u201A"),
            isDetailsSliderOpen && selectedRowData && (React.createElement(AttachedImagesComponent, { isDetailsSliderOpen: isDetailsSliderOpen, setIsDetailsSliderOpen: setIsDetailsSliderOpen, selectedRowData: selectedRowData, handleRejectDispute: handleRejectDispute, handleAcceptDispute: handleAcceptDispute })),
            React.createElement(Popover, { id: copyPopoverId, open: openCopyPopover, anchorEl: copyAnchorEl, onClose: handleCopyClose, slotProps: {
                    paper: {
                        sx: {
                            boxShadow: "0px 4px 4px 0px rgba(206, 216, 228, 0.25)",
                            border: "1px solid #EAEBF1",
                        },
                    },
                }, anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "left",
                } },
                React.createElement(Grid, { container: true, direction: "column", justifyContent: "flex-start", spacing: 0.5, alignItems: "flex-start", sx: { p: 1 } },
                    React.createElement(Grid, { item: true },
                        React.createElement(Typography, { variant: "body2", component: "div", className: "orderTable_small_font" }, "Order Id:")),
                    React.createElement(Grid, { item: true, container: true, direction: "row", alignItems: "center" },
                        React.createElement(Typography, { variant: "body2", sx: { mr: 1 } }, orderId),
                        React.createElement(IconButton, { sx: { color: isOrderIdCopied ? "#0A6EBD" : "inherit" }, onClick: () => handleCopyOrderId(orderId), size: "small" },
                            React.createElement(ContentCopyIcon, { fontSize: "small" }))))),
            React.createElement(Popover, { id: id, open: Boolean(anchorEl), anchorEl: anchorEl, onClose: handleClosePopOver, slotProps: {
                    paper: {
                        sx: {
                            boxShadow: "0px 4px 4px 0px rgba(206, 216, 228, 0.25)",
                            border: "1px solid #EAEBF1",
                            width: "150px",
                            p: 1,
                        },
                    },
                }, anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "center",
                }, transformOrigin: {
                    vertical: "top",
                    horizontal: "right",
                } },
                React.createElement(MenuItem, { onClick: () => {
                        if (selectedRowData) {
                            handleDetailsSlider(selectedRowData);
                            handleClosePopOver();
                        }
                    } }, "Details")))));
};
export default ClosedDisputesComponent;
